module.exports = __webpack_public_path__ + "static/img/black_infantry_archer1.712f11e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/cards/nilfgaardian/black_infantry_archer1.png
// module id = 6YEe
// module chunks = 0